import { CurrencyPipe, DatePipe } from "@angular/common";
import { Injectable } from "@angular/core";
import { HorizontalListData, HorizontalListFactory } from "common";
import { AccountTransferSubmittedDialogData } from "./account-transfer-submitted-dialog.model";

@Injectable()
export class AccountTransferSubmittedDialogAdapter {
  constructor(
    private readonly currencyPipe: CurrencyPipe,
    private readonly datePipe: DatePipe) { }

  adaptHorizontalListData = (data: AccountTransferSubmittedDialogData): HorizontalListData[] => {
    return [
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Outstanding balance',
        displayedValue: this.currencyPipe.transform(data.transferInfo?.balanceAfter?.outstandingBalance, '$')
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Old payment due',
        displayedValue: this.currencyPipe.transform(data.transferInfo?.loanInfo.paymentAmount, '$')
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'New payment due',
        displayedValue: this.currencyPipe.transform(data.transferInfo?.balanceAfter?.upcomingPaymentAmount, '$')
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Payment due date',
        displayedValue: this.preparePaymentDueDateValue(data),
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Credit limit',
        displayedValue: this.currencyPipe.transform(data.transferInfo?.loanOffer?.amount, '$'),
        isItemHidden: data.transferInfo.drawHidden
      }),
    ]
  }

  private preparePaymentDueDateValue(data: AccountTransferSubmittedDialogData): string {
    if (data.transferInfo?.balanceAfter?.upcomingPaymentAmount > 0) {
      return this.datePipe.transform(data.transferInfo?.balanceAfter?.upcomingPaymentDate, 'mediumDate');
    }
    return "None";
  }
}
